import React from "react";
import { PROGRAM_COLORS, PROGRAM_LABELS, PROGRAM_SHORT } from "@/lib/api";

export default function ProgramBadge({ program, size = "sm", showFull = false }) {
  if (!program) return null;
  const color = PROGRAM_COLORS[program] || "#5B6B63";
  const label = showFull ? PROGRAM_LABELS[program] : PROGRAM_SHORT[program] || program;
  const pad = size === "lg" ? "px-3 py-1 text-sm" : "px-2.5 py-0.5 text-xs";
  return (
    <span
      data-testid={`program-badge-${program}`}
      title={PROGRAM_LABELS[program]}
      className={`inline-flex items-center rounded-full font-semibold tracking-wide ${pad}`}
      style={{ backgroundColor: `${color}18`, color, border: `1px solid ${color}44` }}
    >
      {label}
    </span>
  );
}
